//Maybe a library containing ISO 639-3 codes would make sense in the future.
//https://de.wikipedia.org/wiki/%C3%9Cberblicksliste_der_ISO-639-3-Codes
//However, consider the following:
// - it should not make the bundle size too big
// - it should have translations for the languages we support

export const iso639_3Codes = [
  { value: "ger", label: "Deutsch" },
  { value: "eng", label: "English" },
  { value: "gsw", label: "Schweizerdeutsch" },
  { value: "spa", label: "Español" },
  { value: "fra", label: "Français" },
  { value: "ita", label: "Italiano" },
  { value: "zho", label: "中文" },
  { value: "rus", label: "Русский" },
  { value: "ara", label: "العربية" },
  { value: "hin", label: "हिन्दी" },
  { value: "por", label: "Português" },
  { value: "jpn", label: "日本語" },
  { value: "kor", label: "한국어" },
  { value: "tur", label: "Türkçe" },
  { value: "vie", label: "Tiếng Việt" },
  { value: "pol", label: "Polski" },
  { value: "ukr", label: "Українська" },
  { value: "nld", label: "Nederlands" },
  { value: "swe", label: "Svenska" },
  { value: "nor", label: "Norsk" },
  { value: "dan", label: "Dansk" },
  { value: "fin", label: "Suomi" },
  { value: "tha", label: "ไทย" },
  { value: "ell", label: "Ελληνικά" },
  { value: "heb", label: "עברית" },
  { value: "hun", label: "Magyar" },
  { value: "ces", label: "Čeština" },
  { value: "slk", label: "Slovenčina" },
  { value: "ron", label: "Română" },
  { value: "bul", label: "Български" },
  { value: "srp", label: "Српски" },
  { value: "hrv", label: "Hrvatski" },
  { value: "bos", label: "Bosanski" },
  { value: "slv", label: "Slovenščina" },
  { value: "lit", label: "Lietuvių" },
  { value: "lav", label: "Latviešu" },
  { value: "est", label: "Eesti" },
  { value: "ind", label: "Bahasa Indonesia" },
  { value: "tam", label: "தமிழ்" },
  { value: "ben", label: "বাংলা" },
  { value: "mar", label: "मराठी" },
  { value: "urd", label: "اردو" },
  { value: "fas", label: "فارسی" },
  { value: "kur", label: "Kurdî" },
  { value: "aze", label: "Azərbaycan" },
  { value: "kat", label: "ქართული" },
  { value: "arm", label: "Հայերեն" },
  { value: "kaz", label: "Қазақша" },
  { value: "uzb", label: "Oʻzbekcha" },
  { value: "nep", label: "नेपाली" },
] as const;
